import type { TUProfile } from "@entities/user";
import { useProfileStore } from "@features/profile/profile.store";
import { supabase } from "@shared/lib/supabase/client";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export function useProfile() {
  const { setProfile } = useProfileStore();

  return useQuery({
    queryKey: ["profiles"],
    queryFn: async () => {
      const { data: session } = await supabase.auth.getSession();
      const { data } = await supabase
        .from("profiles")
        .select("*")
        .eq("user_id", session.session?.user.id || "")
        .single()
        .throwOnError();

      if (data) {
        setProfile(data);
      }
      return data;
    },
  });
}

export function useUpdateProfile() {
  const profile = useProfileStore((state) => state.profile);

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (updatedProfile: TUProfile) => {
      const { data } = await supabase
        .from("profiles")
        .update(updatedProfile)
        .eq("user_id", profile?.user_id || "")
        .select("*")
        .single()
        .throwOnError();

      queryClient.setQueryData(["profiles"], data);
    },
  });
}
